import React, { useEffect, useRef, useState } from 'react';
import { FaFacebookF, FaInstagram, FaSearch, FaSpotify, FaYoutube } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

// Wrapper per tutte le icone
export const SocialWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  position: relative;
`;

// Tooltip e stile per ogni icona
const IconWrapper = styled.div`
  position: relative;
  display: inline-block;

  .tooltip {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    background-color: black;
    color: white;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 12px;
    white-space: nowrap;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    z-index: 10;
    font-weight: bold;

    &::after {
      content: '';
      position: absolute;
      top: -10px;
      left: 50%;
      transform: translateX(-50%);
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent black transparent;
    }
  }

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`;

const SearchContainer = styled.div`
  position: relative;
`;

const SearchDropdown = styled.div`
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  padding: 8px 12px;
  border: 1px solid black;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  z-index: 99;
      &::after {
      content: '';
      position: absolute;
      top: -10px;
      left: 50%;
      transform: translateX(-50%);
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent black transparent;
    }
`;

const SearchInput = styled.input`
  padding: 6px 10px;
  border: 1px solid transparent;
  border-radius: 4px;
  width: 200px;
  outline: none;
  &:focus {
    border: 1px solid transparent; /* <-- aggiungi questa riga */
    outline: none; /* <-- aggiungi questa riga */
  }
`;

const SocialIcons = ({ isFooter }) => {
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();
  const searchRef = useRef(null);

  // Gestione resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Click fuori dal campo di ricerca
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        setShowSearch(false);
      }
    };
    if (showSearch) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showSearch]);

  // Submit ricerca
  const handleSearchSubmit = (e) => {
    if (e.key === 'Enter' && searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
      setShowSearch(false);
      setSearchQuery('');
    }
  };

  return (
    <SocialWrapper>
      {/* {!isMobile && (
        <SearchContainer ref={searchRef}>
          <IconWrapper>
            <div onClick={() => setShowSearch(prev => !prev)} style={{ cursor: 'pointer' }}>
              <FaSearch style={{ color: isFooter ? 'white' : 'black', width: '20px', height: '20px' }} />
            </div>
            <span className="tooltip">Cerca articoli</span>
          </IconWrapper>
          {showSearch && (
            <SearchDropdown>
              <SearchInput
                type="text"
                placeholder="Cerca articoli..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={handleSearchSubmit}
                autoFocus
              />
            </SearchDropdown>
          )}
        </SearchContainer>
      )} */}

      {[
        {
          name: 'Facebook',
          url: 'https://www.facebook.com/rossomotori.it/',
          icon: FaFacebookF,
          tooltip: 'Seguici su Facebook'
        },
        {
          name: 'Instagram',
          url: 'https://www.instagram.com/rossomotori.it',
          icon: FaInstagram,
          tooltip: 'Seguici su Instagram'
        },
        {
          name: 'YouTube',
          url: 'https://youtube.com/@rossomotori',
          icon: FaYoutube,
          tooltip: 'Seguici su YouTube'
        },
        {
          name: 'Spotify',
          url: 'https://open.spotify.com/show/0coOzWWg3uXgfIPABVny6U?si=83d58a2edb8c421d',
          icon: FaSpotify,
          tooltip: 'Seguici su Spotify'
        }
      ].map(({ name, url, icon: Icon, tooltip }) => (
        <IconWrapper key={name}>
          <Link to={url} target="_blank" rel="noopener noreferrer">
            <Icon style={{ color: isFooter ? 'white' : 'black', width: '20px', height: '20px' }} />
          </Link>
          <span className="tooltip">{tooltip}</span>
        </IconWrapper>
      ))}
    </SocialWrapper>
  );
};

export default SocialIcons;
